import React, { lazy } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductShowcase() {
  const benefits = ['100% Vegan Certified Creatine', 'Zero Sugar, Natural Fruit Flavor', 'Third-party Tested for Purity', 'Brain Clarity & Energy Support'];
  return <div className="bg-[#FDFBF7] border border-gray-200 rounded-xl overflow-hidden my-14 md:my-20 shadow-sm" data-id="element-7">
      <div className="p-6 md:p-10" data-id="element-8">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-9">
          <div className="w-full md:w-1/2" data-id="element-10">
            <div className="aspect-square bg-[#f5f2eb] rounded-lg flex items-center justify-center relative overflow-hidden" data-id="element-11">
              <img src="https://cdn.shopify.com/s/files/1/0936/8453/1542/files/Untitled_design_38.png?v=1768538555" alt="Loomy Vegan Creatine Gummies" className="w-full h-full object-cover mix-blend-multiply" loading="lazy" decoding="async" width="600" height="600" data-id="element-12" />
            </div>
          </div>
          <div className="w-full md:w-1/2 space-y-6" data-id="element-13">
            <div data-id="element-14">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-3" data-id="element-15">
                Loomy Vegan Creatine
              </h3>
              <p className="text-gray-600 font-sans text-base leading-relaxed" data-id="element-16">
                The missing link for plant-based clarity. Simple, effective, and
                designed for your values.
              </p>
            </div>

            <ul className="space-y-3 md:space-y-4" data-id="element-17">
              {benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-18">
                  <div className="mt-1" data-id="element-19">
                    <Check className="w-5 h-5 text-[#7C9885]" strokeWidth={2.5} data-id="element-20" />
                  </div>
                  <span className="text-gray-700 font-medium text-base" data-id="element-21">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="pt-6 border-t border-gray-100" data-id="element-22">
              <CTAButton fullWidth data-id="element-23">Try Loomy</CTAButton>
              <p className="text-center text-xs text-gray-400 mt-3 font-sans" data-id="element-24">
                30-day money-back guarantee. Free shipping.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}